export default "__VITE_ASSET__Bk$BuMhI__"